import React, { Fragment } from "react";

class Button4 extends React.Component {
  render() {
    return (
      <Fragment>
        <div className="text-center p-5">
          <a href="https://tangled.ae/Spellbound-Robot/entry.php?val=4">
            <button type="button" className="btn-lg btn-warning">
              Back
            </button>
          </a>
        </div>
      </Fragment>
    );
  }
}

export default Button4;
